import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Text } from '@chatterbug/aaron'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'

import TutorAvatar from './TutorAvatar'

const STYLES = {
  backgroundColor: 'white100',
  borderColor: 'gray88',
  borderRadius: '1000px',
  borderStyle: 'solid',
  borderWidth: 'small',
}

const OVERFLOW = {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}

const TutorAvatarPill = ({ isPending, name, login, avatarUrl, isFavorite }) => {
  if (isPending) {
    return (
      <Box
        sx={{ ...STYLES }}
        py="0,5x"
        px={{ _: '1x', tablet: '2x' }}
        height={32}
      >
        <Text
          sx={{ ...OVERFLOW }}
          color="gray60"
          mt="-3px"
          variant="text.paragraph"
        >
          {t('Tutor Pending')}
        </Text>
      </Box>
    )
  }

  return (
    <Flex
      borderWidth="small"
      bg="white"
      borderColor="gray88"
      borderRadius="1,5x"
      borderStyle="solid"
      alignItems="center"
      p="0,5x"
      height={32}
      minWidth={100}
      alignSelf="flex-start"
      as="a"
      href={routes.profile({ login: login })}
      color="black19"
      sx={{
        ':hover, :active, :focus': {
          color: 'black19',
          textDecorationColor: 'black19',
        },
      }}
    >
      <TutorAvatar isFavorite={isFavorite} avatarUrl={avatarUrl} name={name} />
      <Text
        mt="-3px"
        // 3px margin left magic value to compensate for width of Favorite (in TutorAvatar) for even spacing
        ml={isFavorite ? '3px' : '1x'}
        mr="1x"
        variant="text.paragraph"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {login}
      </Text>
    </Flex>
  )
}

TutorAvatarPill.propTypes = {
  isPending: PropTypes.bool,
  name: PropTypes.string,
  login: PropTypes.string,
  isFavorite: PropTypes.bool,
  avatarUrl: PropTypes.string,
}

export default TutorAvatarPill
